import { Component } from "@opten/compiler/metadata/component";
import { dialog } from "@opten/dialog";
import { hasClass } from "@opten/dom/has-class";
import { addClass } from "@opten/dom/add-class";
import { Select, SelectOptions } from "@opten/select";
//import { Select, SelectOptions } from './select';
declare var Cookiebot;

@Component({ className: "js-dialog" })
export default class Dialog {
  // todo: better way?
  private _api: any;

  constructor(private element: HTMLElement) {
    const hasWall = hasClass(element, "js-wall");
    if (hasWall) {
      const body = document.getElementsByTagName("body")[0] as HTMLElement;

      element.addEventListener("opened.opten.dialog", () => {
        if (body) {
          addClass(body, "c-wall__container--active");
          if ($ !== undefined && $.validator !== undefined) {
            // get the relevant form
            const $form = $("form");
            if ($form) {
              // delete validator in case someone called form.validate()
              $form.removeData("validator");
              $.validator.unobtrusive.parse($form);
              $form.one("submit", function (e) {
                e.preventDefault();
                if (typeof Cookiebot !== "undefined") {
                  setTimeout(() => {
                    Cookiebot.submitCustomConsent(true, true, true);
                  }, 300);
                }
                $(this).submit();
              });
            }
          }

          // initialize selects
          Array.from(
            body.querySelectorAll(".c-overlay__container .js-select-dialog")
          ).forEach(
            (element) =>
              new Select(
                element as HTMLSelectElement,
                {
                  classes: {
                    component: "c-select",
                    active: "--active",
                    highlighted: "--highlighted",
                    disabled: "--disabled",
                    iconHtml: "",
                  },
                } as SelectOptions
              )
          );
        }
        element.parentElement.removeChild(element);
      });
    }
    this._api = dialog(element, {
      maxWidth: 1200,
      disableClose: hasWall,
    });
    if (hasWall) {
      this._api.open();
    }
  }

  toggle() {
    // todo: better way?
    this._api._toggle();
  }
}
